import StudentProfileName from "../../../Components/StudentProfileName";
import { t } from "i18next";
import StatusBanner from "../../../Components/StatusBanner";
import ExerciseAttemptInfo from "../../../Components/ExerciseAttemptInfo";
import LessonHeader from "../../../Components/LessonHeader";
import ExerciseRubrics from "../../../Components/ExerciseRubrics";

export const LessonExerciseInitialNote = (props) => {
  const {
    slidePosition,
    globalState,
    rubrics,
    deadLine,
    mode,
    apiInfo,
      statusBanner,
    exercises,
  } = props;

  return (
    <div
      className={`slideNote slideNote${slidePosition} initialNote`}
      id="initialNote"
      key={`initialNote`}
      data-position={slidePosition}
      data-navigation="false">

      {statusBanner !== "" ? (
          <StatusBanner
              lessonType={globalState.lessonType}
              statusBannerType={statusBanner} />
      ) : null}

      <div className="slideNoteWrapper">
        {globalState.apiInfo.student && globalState.role !== "student" ? (
            <StudentProfileName
                studentProfile={globalState.apiInfo.student}
                mode='inline'
            />
        ) : null}
        <div className="slideNoteContent">
          <div className="container">

              <LessonHeader globalState={globalState} deadLine={deadLine} mode={mode} apiInfo={apiInfo}
                            rubrics={rubrics} lessonName={globalState.lesson.name} />

              {mode === "display_with_data" ? (
                <div className="row">
                  <div className="col-12">
                    <ExerciseAttemptInfo exercises={exercises} results={apiInfo.params.answers.results} globalState={globalState} title={t("average.first")} showBadge={true} />
                  </div>
                </div>
              ) : null}

              {mode === "solve_retry" ? (
                <div className="row">
                  <div className="col-12">
                    <div className="attemptInfoLite">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.8013 1.00173L14.9122 1.22198L15.7414 3.42882C15.8061 3.60156 15.9429 3.73976 16.1171 3.80454L18.2476 4.60493C19.1833 4.95474 19.6857 5.95379 19.4367 6.89957L19.3762 7.08672L18.3858 9.27915C18.3477 9.36276 18.328 9.45358 18.328 9.54547C18.328 9.63736 18.3477 9.72818 18.3858 9.81179L19.3273 11.8847C19.5243 12.3193 19.5532 12.8114 19.4086 13.266C19.264 13.7206 18.956 14.1055 18.5442 14.3464L18.3239 14.4572L16.1171 15.2864C16.0316 15.3188 15.954 15.3691 15.8894 15.4339C15.8249 15.4987 15.7749 15.5765 15.7428 15.6621L14.9424 17.7927C14.7748 18.24 14.4473 18.6092 14.0231 18.8289C13.5989 19.0485 13.1083 19.103 12.6463 18.9817L12.4592 18.9213L10.2667 17.9309C10.1831 17.8927 10.0923 17.873 10.0004 17.873C9.90854 17.873 9.81772 17.8927 9.73411 17.9309L7.6626 18.8723C7.22808 19.0693 6.73598 19.0983 6.28134 18.9536C5.82671 18.809 5.4418 18.501 5.20096 18.0892L5.09012 17.869L4.2595 15.6621C4.22706 15.5766 4.17678 15.499 4.11199 15.4345C4.0472 15.3699 3.9694 15.3199 3.88378 15.2878L1.75324 14.4874C1.30593 14.3199 0.936707 13.9923 0.717046 13.5681C0.497385 13.144 0.442911 12.6534 0.56417 12.1914L0.624631 12.0042L1.61648 9.81179C1.65451 9.72815 1.67418 9.63734 1.67418 9.54547C1.67418 9.4536 1.65451 9.36279 1.61648 9.27915L0.673576 7.20764C0.47647 6.77329 0.447279 6.28131 0.591638 5.8267C0.735998 5.37208 1.04367 4.98707 1.45525 4.74601L1.6755 4.63516L3.88378 3.8031C3.96954 3.77084 4.04743 3.72063 4.11223 3.65583C4.17703 3.59103 4.22724 3.51315 4.2595 3.42738L5.05989 1.29684C5.22745 0.849843 5.5548 0.480852 5.97864 0.261219C6.40249 0.0415852 6.89271 -0.0130878 7.35453 0.107772L7.54167 0.168233L9.73411 1.16008C9.81775 1.19811 9.90856 1.21778 10.0004 1.21778C10.0923 1.21778 10.1831 1.19811 10.2667 1.16008L12.3397 0.218617C12.7741 0.0215112 13.266 -0.00767992 13.7206 0.13668C14.1753 0.281039 14.5603 0.588712 14.8013 1.00029V1.00173ZM13.1171 6.24314L8.52921 11.4831L6.85645 9.81035C6.73492 9.69406 6.57268 9.62998 6.40449 9.63183C6.23629 9.63368 6.07551 9.70132 5.95657 9.82026C5.83763 9.9392 5.76999 10.1 5.76814 10.2682C5.76628 10.4364 5.83036 10.5986 5.94665 10.7201L8.10598 12.8795C8.1683 12.9416 8.24271 12.9904 8.32461 13.0226C8.40651 13.0549 8.49416 13.07 8.58214 13.067C8.67011 13.0641 8.75654 13.0431 8.83608 13.0054C8.91562 12.9677 8.98658 12.914 9.04457 12.8478L14.083 7.0896C14.1856 6.96009 14.2344 6.79608 14.2194 6.63155C14.2044 6.46701 14.1267 6.31456 14.0023 6.20576C13.878 6.09696 13.7166 6.04016 13.5515 6.04712C13.3864 6.05408 13.2304 6.12426 13.1156 6.24314H13.1171Z"
                          fill="#004980"
                        />
                      </svg>
                      <div className="item">
                        <div className="title">{t("average.first")}:</div>
                        <div className="value">
                          {apiInfo.params.answers.results.score}
                        </div>
                      </div>
                      {rubrics.map((rubric, index) => {
                        let competence_id =
                          rubric.evaluationItem?.competence?.sys.id;
                        let result =
                          apiInfo.params?.answers?.results?.competencies?.filter(
                            (c) => c.competency === competence_id
                          )[0];
                        return (
                          <div className="item" key={`rubricItem${index}`}>
                            <div className="title">{rubric.idName}:</div>
                            <div className="value">{result.level ?? "-"}</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              ) : null}

              <ExerciseRubrics rubrics={rubrics} apiInfo={apiInfo} mode={mode} />

          </div>
        </div>
      </div>
    </div>
  );
};
